import { PayoutMethod } from '@/types/api/payout-account';
import { RadioGroup } from '../ui/radio-group';
import PayoutMethodRadioCard from './PayoutMethodRadioCard';
import { useFormContext } from '@/contexts/form-context';

interface PayoutMethodRadioProps {}

export default function PayoutMethodRadio({}: PayoutMethodRadioProps) {
  const form = useFormContext();

  return (
    <form.Field
      name="payoutMethod"
      children={(field) => (
        <RadioGroup
          className="flex flex-col gap-2"
          defaultValue={PayoutMethod.BankTransfer}
          onValueChange={(value: PayoutMethod) => {
            field.handleChange(value);
          }}
        >
          <PayoutMethodRadioCard payoutMethod={PayoutMethod.BankTransfer} />
          <PayoutMethodRadioCard payoutMethod={PayoutMethod.Swish} />
        </RadioGroup>
      )}
    />
  );
}
